import styled, { css } from 'styled-components';
import { type ILevelItem, LevelState } from '../../../helpers';

interface IScCardHudProps {
  $lvlState: ILevelItem['state'];
}

// 'issued' never reaches ScCardHud (LevelCard swaps in the claim button
// instead), but the map stays exhaustive over LevelState for type-safety.
const activeStyles = css`
  .cardHudFill {
    fill: rgba(37, 170, 214, 0.1);
    fill-opacity: 1;
  }

  .cardHudStroke {
    stroke: rgba(37, 170, 214, 0.8);
    stroke-width: 1.2px;
  }
`;

interface IDimHudStylesOptions {
  rewardColor?: string;
  progressColor?: string;
}

const dimHudStyles = (
  opacity: number,
  color: string,
  { rewardColor = color, progressColor }: IDimHudStylesOptions = {}
) => css`
  opacity: ${opacity};
  color: ${color};

  ${
    progressColor &&
    css`
    .hudProgress {
      color: ${progressColor};
    }
  `
  }

  .hudReward {
    color: ${rewardColor};
  }
`;

const doneStyles = dimHudStyles(0.6, '#93db37', { progressColor: '#93db37' });

const lockedStyles = dimHudStyles(0.8, '#8e8e93', { rewardColor: '#d3d3d9' });

const canceledStyles = dimHudStyles(0.6, '#ff333a', {
  progressColor: '#ff333a',
});

const CARD_HUD_STATE_STYLES: Record<LevelState, ReturnType<typeof css>> = {
  [LevelState.Active]: activeStyles,
  [LevelState.Issued]: activeStyles,
  [LevelState.Done]: doneStyles,
  [LevelState.Locked]: lockedStyles,
  [LevelState.Canceled]: canceledStyles,
};

export const ScCardHud = styled.div<IScCardHudProps>`
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  width: 116px;
  margin: 0 auto;
  height: 40px;
  bottom: 0;
  transform: translateY(-12px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 8px 4px;
  color: #f79f37;

  .hudProgress {
    font-size: 10px;
    line-height: 14px;
    color: #c1c2c5;
  }

  .hudReward {
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.14px;
    text-transform: uppercase;
    color: #4ec4eb;
    margin-top: -2px;
  }

  .cardHudBg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  svg.cardHudBg {
    transform: scaleX(-1);
  }

  ${({ $lvlState }) => CARD_HUD_STATE_STYLES[$lvlState]}
`;
